<!--公共面包屑-->
<template>
  <div class="breadcrumb-wrapper clearfix">
    <el-breadcrumb separator="/" class="left">
      <el-breadcrumb-item>{{this.$route.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="right"><slot name="button"></slot></div>
  </div>
</template>

<script>
  export default {
    props: {
      firstLevel: {
        type: String,
        default: '首页'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "~common/scss/variable.scss";
  .breadcrumb-wrapper{
    background-color: $color-background-white;
    border:1px solid $color-border;
    padding:10px 15px;
    .el-breadcrumb{
      height:32px;
      line-height:32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base/breadcrumb/breadcrumb.vue